import { onUnmounted, watch } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useDoNotDisturb from "@/hooks/useDoNotDisturb";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";
import integrations from "./integrations";
import { importantPushEnum } from "../../const";
import { NotificationFactory } from "../../index";

export default function(sendNotification: NotificationFactory) {
  const { authUser } = useAuthUser();
  const { doNotDisturb } = useDoNotDisturb();
  const onNotification = (notificationData: Notification) => {
    emitter.emit(EVENTS.NOTIFICATIONS_NEW_NOTIFICATION, notificationData);
    if (doNotDisturb.value && !importantPushEnum.includes(notificationData.type)) return;
    for (const integration of integrations) {
      const notification = integration(notificationData);
      if (notification) {
        sendNotification(notification);
        break;
      }
    }
  };

  let unSubscribe = () => {};
  const subscribe = async () => {
    unSubscribe();
    const unsubscribe = await providers.NotificationsProvider.subscribeNotification(onNotification);
    unSubscribe = () => unsubscribe.unsubscribe();
  };
  watch(
    authUser,
    (n, o) => {
      if (!n) {
        unSubscribe();
      } else if (!o) {
        subscribe();
      }
    },
    { immediate: true }
  );
  onUnmounted(() => unSubscribe());
}
